export default __webpack_public_path__ + "static/media/skola-banner-secondary.b13ed05f.png";